module.exports = "https://static.im-cdn.com/mjc/storefront/Accent/static/media/Flinkedin.bd1fe569.svg";